import { Pipe, PipeTransform } from '@angular/core';
import { Many, orderBy } from 'lodash';

@Pipe({ name: 'sortBy' })
export class SortByPipe implements PipeTransform {

    transform<T>(value: T[], order: Many<boolean | "asc" | "desc"> = 'asc', column = ''): T[] {
        if (!value) { return value; } // no array
        if (value.length <= 1) { return value; } // array with only one item
        if (!column || column === '') {
            if (order === 'asc') { return value.sort() }
            else { return value.sort().reverse(); }
        } // sort 1d array
        return orderBy(value, [value => (value as Record<string, unknown>)[column]?.toString()?.toLowerCase() || (value as Record<string, unknown>)[column]], order);
    }
}